module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"a":"Technologies...","b":"Labels"},"en":{"a":"Technologies...","b":"Labels"}}')
  delete Component.options._Ctor
}
